goog.provide('el8.ptdata.model.lab');

goog.require('el8.data.referencedUsers');
goog.require('el8.data.testCenters');
goog.require('el8.model.base');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.ptdata.model.lab');


// --------------
// ** LAB TEST **
// --------------

(function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name');
    _class.addStringProperty('code');
    el8.ptdata.model.lab.test = function(spec) {
        return new _class(spec);
    };
})();


// -----------------------
// ** LAB TEST CATEGORY **
// -----------------------

(function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name');
    _class.addIntProperty('vendorId');
    el8.ptdata.model.lab.testCategory = function(spec) {
        return new _class(spec);
    };
})();


// ----------------
// ** LAB RESULT **
// ----------------

(function() {
    var _class = function(spec) {

        if (spec.location) {
            spec.location_id = spec.location.id;
            el8.data.testCenters.labResult.create(spec.location);
        }

        this.populate(spec);

    };
    _class.inheritsFrom(el8_Entity);

    _class.addIntProperty("reportId");
    _class.addModelProperty("labTest", el8.ptdata.model.lab.test, true);
    _class.addModelProperty("labTestCategory", el8.ptdata.model.lab.testCategory, true);

    // The value for the result e.g. 7.0 - can be blank
    _class.addStringProperty("value");
    _class.addStringProperty("valueType");
    
    // The value for a 'report' lab result.  The result value is a bunch of text
    _class.addStringProperty("textReportResultValue");

    // A note that was entered by the lab as part of this result
    _class.addStringProperty("referenceMin");
    _class.addStringProperty("referenceMax");
    _class.addStringProperty("units");
    _class.addBoolean('numericReferenceRange');

    _class.addBoolean("starred");
    _class.addBoolean("abnormal");
    _class.addStringProperty("abnormalFlag");
    _class.addStringProperty("abnormalDescription");
    _class.addStringProperty("resultStatusCode");

    _class.addStringProperty("resultValueNote");
    _class.addBoolean("resultValueNoteFormatted"); // preformatted? i.e. should be show horizontal scrollbars?

    _class.addDateTime("collectedDate");
    _class.addIntProperty('documentingPersonnelId');

    _class.addModelSetProperty('previousResults', function(spec) {
        return el8.ptdata.model.lab.resultRow(spec);
    }, false, []);
    _class.addBoolean('cancelledNonPerformance');

    // Information about performing lab center
    _class.addIntProperty('locationId');
    _class.prototype.getLocation = function() {
        return this.getLocationId() ?
            el8.data.testCenters.labResult.getById(this.getLocationId()) : null;
    };

    // ---------------------------
    // Adding prototype methods
    // ---------------------------
    var getDocumentingPersonnel = function(obj) {
        var personnelId = obj.getDocumentingPersonnelId();
        if (personnelId) {
            return el8.data.referencedUsers.getById(personnelId);
        }
        return null;
    };
    _class.prototype.getDocumentingPersonnelName = function() {
        var user = getDocumentingPersonnel(this);
        return user ? user.getFullName() : '';
    };
    _class.prototype.getDocumentingPersonnelType = function() {
        var user = getDocumentingPersonnel(this);
        return user ? user.getStaffType() : '';
    };
    
    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.model.lab.noteSummary(this.asSoyMap()).el8_unescape();
    };

    _class.prototype.getNoteSummaryWithPrevDates = function() {
        var soyMap = this.asSoyMap();
        soyMap['showPrevCollectedDates'] = true;
        return el8.template.ptdata.model.lab.noteSummary(soyMap).el8_unescape();
    };

    _class.prototype.save = function( callbackFn ) {
        $.el8_ajax({
            type: "POST",
            url: el8.service.urls.get('labResults', [this]),
            data: { 'isStarred': this.isStarred() },
            success: callbackFn
        });
    };


    _class.prototype.asSoyMap = function() {

        var numPrev = 3;
        var numNonNullPrev = 0;
        var nPrevResults = [];
        var priorResults = this.getPreviousResults();
        for (var j=1; j<=numPrev; j++) {
            if(priorResults.length >= j) {
                numNonNullPrev++;
                var currResult = priorResults[j-1];
                nPrevResults.push({ // just get the values we need
                    collectedDate: el8.service.tz.soyStr(currResult.getCollectedDate()),
                    isAbnormal : currResult.isAbnormal(),
                    abnormalFlag : currResult.getAbnormalFlag(),
                    /* Explicitly do NOT include textReportResultValue, since we don't show that in prev results */
                    value : currResult.getValue(),
                    documentingPersonnelName: currResult.getDocumentingPersonnelName(),
                    documentingPersonnelType: currResult.getDocumentingPersonnelType()
                });
            } else {
                nPrevResults.push(null);
            }
        }

        // we're going to define prevResults instead of previousResults, so no need to encode it twice
        var mapped = this.parent.asSoyMap.call(this, ['previousResults']);

        mapped['labTest'] = this.getLabTest() ? this.getLabTest().asSoyMap() : null;
        mapped['location'] = this.getLocation() ? this.getLocation().asSoyMap() : null;

        mapped['prevResults'] = nPrevResults; // does not exist on encode_json, that's ok
        mapped['numPrevResults'] = numNonNullPrev;

        mapped['documentingPersonnelName'] = this.getDocumentingPersonnelName();
        mapped['documentingPersonnelType'] = this.getDocumentingPersonnelType();

        return mapped;

    };

    el8.ptdata.model.lab.resultRow = function(spec) {
        return new _class(spec);
    };

})();


// ---------------------
// ** LAB RESULT GRID **
// ---------------------

(function() {

    var resultsById = {};
    var _class = function(spec) {

        var parseElt = function(d) {
            var parseRow = function(r) {
                if (r.parent && resultsById.hasOwnProperty(r.getId())) {
                    return resultsById[r.getId()];
                } else {
                    var curr = el8.ptdata.model.lab.resultRow(r);
                    resultsById[curr.getId()] = curr;
                    return curr;
                }
            };
            return {
                label: d.label,
                rows: d.rows.map(parseRow)
            };
        };
        spec.results_by_category = spec.results_by_category.map(parseElt);

        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.makeSignable();

    _class.addStringProperty('status');
    _class.addStringProperty('accessionNumber');
    _class.addDateTime('resultedDate');
    _class.addDateTime('collectedDate');
    _class.addBoolean('collectedDateProvided');
    _class.addStringProperty('labReportNote');
    _class.addStringProperty('resultCopiesTo');

    _class.addProperty('resultsByCategory'); // this is a list

    _class.prototype.getResultById = function(id) {
        return resultsById[id*1];
    };

    _class.prototype.getStarredResultRows = function() {

        var resultsByCategory = this.getResultsByCategory();
        var starredRows = [];

        for (var i=0; i<resultsByCategory.length; i++) {
            var rows = resultsByCategory[i]['rows'];
            for (var j=0; j<rows.length; j++) {
                if (rows[j].isStarred()) {
                    starredRows.push(rows[j]);
                }
            }
        }

        return starredRows;
    };

    _class.prototype.getAbnormalResultRows = function() {

        var resultsByCategory = this.getResultsByCategory();
        var abnormalRows = [];

        for (var i=0; i<resultsByCategory.length; i++) {
            var rows = resultsByCategory[i]['rows'];
            for (var j=0; j<rows.length; j++) {
                if (rows[j].isAbnormal()) {
                    abnormalRows.push(rows[j]);
                }
            }
        }

        return abnormalRows;
    };

    _class.prototype.asSoyMap = function() {

        var mapped = this.parent.asSoyMap.call(this);
        var mapFn = function(a) {
            return {
                label: a.label,
                rows: a.rows.map(el8.model.toSoyMapFn)
            };
        };
        mapped['resultsByCategory'] = this.getResultsByCategory().map(mapFn);
        return mapped;

    };

    el8.ptdata.model.lab.resultGrid = function(spec) {
        return new _class(spec);
    };

})();


